var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message-wrap" },
    [
      _c("div", { staticClass: "message-header__wrap" }, [
        _c("div", { staticClass: "message-header" }, [
          _c("span", [_vm._v("消息通知")]),
          _c(
            "span",
            { staticClass: "message-more", on: { click: _vm.toMessageCenter } },
            [_vm._v(_vm._s(_vm.$t("system::common::dialog::message_more")))]
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "message-list" },
        [
          _vm._l(_vm.messageList, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "message-item__wrap",
                class: { "not-read": !item.status },
                on: {
                  click: function ($event) {
                    return _vm.toMessageCenter(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "message-item" }, [
                  _c("div", { staticClass: "message-title__wrap" }, [
                    _c(
                      "div",
                      {
                        staticClass: "message-title one-line",
                        class: { "have-read": item.status },
                      },
                      [
                        _vm._v(
                          " [" +
                            _vm._s(_vm.typeMap[item.messageType]) +
                            "] " +
                            _vm._s(item.header) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "message-time",
                        class: { "have-read": item.status },
                      },
                      [_vm._v(_vm._s(item.pushTime))]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "message-content more-line",
                      class: { "have-read": item.status },
                    },
                    [_vm._v(" " + _vm._s(item.message) + " ")]
                  ),
                ]),
              ]
            )
          }),
          _c("default-data", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.messageList.length,
                expression: "!messageList.length",
              },
            ],
            staticStyle: { height: "200px" },
            attrs: { custom: { text: "暂无消息" } },
          }),
        ],
        2
      ),
      _c("ShowDetail", {
        attrs: { message: _vm.message },
        model: {
          value: _vm.visible,
          callback: function ($$v) {
            _vm.visible = $$v
          },
          expression: "visible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }